import { render, staticRenderFns } from "./CreateTeller.vue?vue&type=template&id=5bc6be91&scoped=true&"
import script from "./CreateTeller.vue?vue&type=script&lang=js&"
export * from "./CreateTeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6be91",
  null
  
)

export default component.exports